import { useTheme } from '@mui/material/styles';
import { BarLabels } from './BarLabels';
import { BarContainer, BarFiller, BarWrapper } from './styledComponents';
import { getBufferFillerWidth, getProgressFillerWidth } from './utils';

export interface Props {
  value: number;
  bufferValue: number;
  baseColor: string;
  progressLabel: string;
  progressValueLabel: string;
  totalLabel: string;
  totalValueLabel: string;
}

export const ProgressBar = ({
  value,
  bufferValue,
  baseColor,
  progressValueLabel,
  totalValueLabel,
  progressLabel,
  totalLabel
}: Props) => {
  const theme = useTheme();

  const bufferFillerWidth = getBufferFillerWidth({
    value,
    bufferValue
  });

  const progressFillerWidth = getProgressFillerWidth({
    value,
    bufferValue
  });

  return (
    <BarWrapper>
      <BarLabels leftSide={progressValueLabel} rightSide={totalValueLabel} />
      <BarContainer
        data-testid="progress-bar"
        role="progressBar"
        backgroundColor={baseColor}
      >
        <BarFiller
          data-testid="buffer-filler"
          width={bufferFillerWidth}
          backgroundColor={theme.palette.primary.main}
          visibility={bufferValue === 0 ? 'hidden' : 'visible'}
        >
          <BarFiller
            data-testid="progress-filler"
            width={progressFillerWidth}
            visibility={value === 0 ? 'hidden' : 'visible'}
          />
        </BarFiller>
      </BarContainer>
      <BarLabels leftSide={progressLabel} rightSide={totalLabel} />
    </BarWrapper>
  );
};
